module.exports = __webpack_public_path__ + "static/charo2-89884164b1e174490ddc66add8a42b79.png";